export default {
	notification_health: 'Состояние уведомлений',
	notification_health_summary: 'Сводка',
	notification_health_loading: 'Проверка состояния уведомлений...',
	notification_health_refresh: 'Обновить',
	notification_health_fix: 'Что делать',
	notification_health_unavailable: 'Не удалось загрузить состояние уведомлений',
	notification_health_healthy: 'Исправно',
	notification_health_blocked: 'Заблокировано',
	notification_health_degraded: 'Требует внимания',
	notification_health_no_app_user: 'Нет входа в приложение',
	notification_health_unknown: 'Неизвестно',
	notification_health_app_version: 'Версия приложения',
	notification_health_last_delivery: 'Последняя доставка',
	notification_health_time_just_now: 'только что',
	notification_health_time_minutes: '{count} мин. назад',
	notification_health_time_hours: '{count} ч. назад',
	notification_health_time_days: '{count} дн. назад',
	notification_health_time_unknown: 'неизвестно',
	notification_health_summary_healthy: 'Уведомления должны работать',
	notification_health_summary_no_app_user: 'Уборщик не входил в мобильное приложение',
	notification_health_summary_blocked_no_token: 'Push-токен отсутствует — уборщик должен открыть приложение и войти',
	notification_health_summary_blocked_off: 'Уведомления отключены в приложении',
	notification_health_check_portal_contact_label: 'Контакт в портале существует',
	notification_health_check_portal_active_label: 'Контакт активен',
	notification_health_check_portal_rooms_label: 'Комнаты назначены',
	notification_health_check_portal_shifts_label: 'Смены назначены',
	notification_health_check_app_user_label: 'Вход в мобильное приложение',
	notification_health_check_push_token_label: 'Push-токен зарегистрирован',
	notification_health_check_notification_mode_label: 'Режим уведомлений',
	notification_health_check_time_schedule_label: 'В пределах окна уведомлений',
	notification_health_check_ios_geo_filter_label: 'Фильтр местоположения iOS',
	notification_health_check_recent_push_attempt_label: 'Недавняя попытка push (48 ч)',
	notification_health_check_last_push_ignored_label: 'Последний сигнал не был отправлен',
	notification_health_check_recent_push_delivered_label: 'Недавняя доставка push (48 ч)',
	notification_health_detail_portal_contact_found: 'Найден в портале',
	notification_health_detail_portal_contact_missing: 'Запись контакта не найдена',
	notification_health_detail_portal_active_active: 'Активен',
	notification_health_detail_portal_active_inactive: 'Неактивен',
	notification_health_detail_portal_rooms_assigned: '{count} комн.',
	notification_health_detail_portal_rooms_none: 'Комнаты не назначены',
	notification_health_detail_portal_shifts_assigned: '{count} смен(ы)',
	notification_health_detail_portal_shifts_none: 'Смены не назначены',
	notification_health_detail_app_user_logged_in: 'Версия приложения {version}, последняя синхронизация {lastSync}',
	notification_health_detail_app_user_never: 'Никогда не входил',
	notification_health_detail_push_token_present: 'FCM-токен присутствует',
	notification_health_detail_push_token_empty: 'Токен пуст',
	notification_health_detail_notification_mode: '{mode}',
	notification_health_detail_time_schedule_inside: 'Текущее время в пределах расписания',
	notification_health_detail_time_schedule_outside: 'Текущее время вне настроенного расписания',
	notification_health_detail_ios_geo_filter: '{filter}',
	notification_health_detail_recent_push_attempt_at: '{time}',
	notification_health_detail_recent_push_attempt_none: 'Нет попыток push за последние 48 часов',
	notification_health_detail_last_push_ignored: 'Последний запрос push был проигнорирован (servik не настроен для рабочей зоны)',
	notification_health_detail_recent_push_delivered_at: '{time}',
	notification_health_detail_recent_push_delivered_none: 'Нет успешных доставок за последние 48 часов',
	notification_health_fix_portal_contact: 'Создайте этого уборщика в панели Пользователи',
	notification_health_fix_portal_active: 'Включите переключатель Активен для этого уборщика',
	notification_health_fix_portal_rooms: 'Назначьте хотя бы одну комнату этому уборщику',
	notification_health_fix_portal_shifts: 'Назначьте хотя бы одну смену',
	notification_health_fix_app_user: 'Уборщик должен установить приложение и войти с этим номером телефона',
	notification_health_fix_push_token: 'Попросите уборщика открыть приложение, разрешить уведомления в настройках iOS и войти снова',
	notification_health_fix_notification_mode: 'Измените режим уведомлений с Выкл. на Всегда в приложении',
	notification_health_fix_time_schedule: 'Дождитесь запланированного окна или измените режим на Всегда',
	notification_health_fix_ios_geo_filter: 'Уборщик вне зоны уведомлений — попросите открыть приложение на объекте',
	notification_health_fix_last_push_ignored: 'Проверьте конфигурацию servik рабочей зоны для комнаты, вызвавшей сигнал',
	notification_health_fix_recent_push_delivered_filters: 'Проверьте фильтры уведомлений или настройки устройства',
	notification_health_fix_recent_push_delivered_token: 'Сначала зарегистрируйте push-токен',
	notification_health_mode_on: 'Всегда',
	notification_health_mode_off: 'Выкл.',
	notification_health_mode_time: 'По расписанию',
	notification_health_mode_location: 'По местоположению',
	notification_health_filter_on: 'Вкл.',
	notification_health_filter_off: 'Выкл.',
};
